// import _ from 'lodash'
import axios from 'axios'

export default (props) => {
  const aio = axios.create(props)

  return {
    ...aio,
    get: (...args) => {
      const url = args[0]

      if(url === '/keys/') {
        return Promise.resolve({
          data: require('../fixtures/keys.json')
        })
      } else if (url === '/keys/homer.bardels.me') {
        return Promise.resolve({
          data: require('../fixtures/get_key.homer.json')
        })
      } else if (url === '/keys/maggie.bardels.me') {
        return Promise.resolve({
          data: require('../fixtures/get_key.maggie.json')
        })
      } else if (url.startsWith('/minions/')) {
        return Promise.resolve({
          data: require('../fixtures/minions.json')
        })
      } else if (url === '/stats') {
        return Promise.resolve({
          data: require('../fixtures/stats.json')
        })
      } else if (url === '/') {
        return Promise.resolve({
          data: require('../fixtures/welcome.json')
        })
      // } else if (url === '/jobs/') {
      //   return Promise.resolve({
      //     data: require('../fixtures/jobs.json')
      //   })
      } else if (url.startsWith('/jobs/2017110906')) {
        return Promise.resolve({
          data: require('../fixtures/get_job.json')
        })
      } else { return aio.get(...args) }
    }
  }

}



// WEBPACK FOOTER //
// ./src/saltapi/mock.js